
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("iNgWr", function(module, exports) {
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ 
module.exports = (parcelRequire("5UWLS"));

});
parcelRegister("5UWLS", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");

var $zTYoH = parcelRequire("zTYoH");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $44efc5708ae02dcc$var$_extends2 = $l4FIw((parcelRequire("5WrMC")));

var $44efc5708ae02dcc$var$_objectWithoutProperties2 = $l4FIw((parcelRequire("ib1Q9")));

var $44efc5708ae02dcc$var$_classCallCheck2 = $l4FIw((parcelRequire("amPRp")));

var $44efc5708ae02dcc$var$_createClass2 = $l4FIw((parcelRequire("5pBBk")));

var $44efc5708ae02dcc$var$_possibleConstructorReturn2 = $l4FIw((parcelRequire("35on9")));

var $44efc5708ae02dcc$var$_getPrototypeOf3 = $l4FIw((parcelRequire("8yP2g")));

var $44efc5708ae02dcc$var$_assertThisInitialized2 = $l4FIw((parcelRequire("i4RG1")));

var $44efc5708ae02dcc$var$_inherits2 = $l4FIw((parcelRequire("eGfZt")));

var $44efc5708ae02dcc$var$_defineProperty2 = $l4FIw((parcelRequire("jIgr0")));

var $8lubB = parcelRequire("8lubB");

var $44efc5708ae02dcc$var$_classnames = $l4FIw((parcelRequire("g3elz")));

var $2xydG = parcelRequire("2xydG");

var $44efc5708ae02dcc$var$_convertUnsafeMethod = $l4FIw((parcelRequire("clRb7")));

var $44efc5708ae02dcc$var$_CornerTriangle = $l4FIw((parcelRequire("8XmkT")));

var $44efc5708ae02dcc$var$_filterDOMProps = $l4FIw((parcelRequire("8ktw3")));

var $44efc5708ae02dcc$var$_focusRing = $zTYoH((parcelRequire("6B4CL")));

var $44efc5708ae02dcc$var$_propTypes = $l4FIw((parcelRequire("h4kRK")));

var $44efc5708ae02dcc$var$_react = $zTYoH((parcelRequire("7eprg")));

var $44efc5708ae02dcc$var$_class, $44efc5708ae02dcc$var$_class2, $44efc5708ae02dcc$var$_temp;





// For backward compatibility with coral
var $44efc5708ae02dcc$var$VARIANTS = {
    quiet: {
        variant: "primary",
        quiet: true
    },
    minimal: {
        variant: "secondary",
        quiet: true
    },
    icon: {
        variant: "action",
        quiet: true
    }
};
/**
 * A **button** represents an action a user can take. Buttons can be clicked or tapped to
 * perform an action or to navigate to another page. Buttons in Spectrum have several variations
 * for different uses and multiple levels of loudness for various attention-getting needs.
 */ var $44efc5708ae02dcc$var$Button = (0, $44efc5708ae02dcc$var$_convertUnsafeMethod["default"])($44efc5708ae02dcc$var$_class = (0, $44efc5708ae02dcc$var$_focusRing["default"])($44efc5708ae02dcc$var$_class = ($44efc5708ae02dcc$var$_temp = $44efc5708ae02dcc$var$_class2 = /*#__PURE__*/ function(_Component) {
    (0, $44efc5708ae02dcc$var$_inherits2["default"])(Button, _Component);
    function Button() {
        var _getPrototypeOf2;
        var _this;
        (0, $44efc5708ae02dcc$var$_classCallCheck2["default"])(this, Button);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $44efc5708ae02dcc$var$_possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, $44efc5708ae02dcc$var$_getPrototypeOf3["default"])(Button)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $44efc5708ae02dcc$var$_defineProperty2["default"])((0, $44efc5708ae02dcc$var$_assertThisInitialized2["default"])(_this), "onClick", function(event) {
            // This is needed when `element` is an anchor or something similar.
            // When `element` is a button, we won't even get here if it's disabled and clicked.
            if (_this.props.disabled) // If the element is an anchor with an href, we need to preventDefault() or the browser
            // will follow the link.
            event.preventDefault();
            else if (_this.props.onClick) {
                var _this$props;
                for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
                (_this$props = _this.props).onClick.apply(_this$props, [
                    event
                ].concat(rest));
            }
        });
        (0, $44efc5708ae02dcc$var$_defineProperty2["default"])((0, $44efc5708ae02dcc$var$_assertThisInitialized2["default"])(_this), "onKeyDownSpace", function(event) {
            if (event.key === " " || event.key === "Enter") {
                event.preventDefault();
                _this.buttonRef.click();
            }
        });
        (0, $44efc5708ae02dcc$var$_defineProperty2["default"])((0, $44efc5708ae02dcc$var$_assertThisInitialized2["default"])(_this), "setButtonRef", function(b) {
            return _this.buttonRef = b;
        });
        return _this;
    }
    (0, $44efc5708ae02dcc$var$_createClass2["default"])(Button, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                if (this.props.autoFocus) // wait a frame to make sure the button in the DOM and focusable
                requestAnimationFrame(function() {
                    return _this2.focus();
                });
            }
        },
        {
            key: "focus",
            value: function focus() {
                if (this.buttonRef && !this.props.disabled && this.buttonRef.focus) this.buttonRef.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, _this$props2$element = _this$props2.element, Element = _this$props2$element === void 0 ? "button" : _this$props2$element, label = _this$props2.label, children = _this$props2.children, _this$props2$variant = _this$props2.variant, variant = _this$props2$variant === void 0 ? "secondary" : _this$props2$variant, logic = _this$props2.logic, quiet = _this$props2.quiet, icon = _this$props2.icon, selected = _this$props2.selected, block = _this$props2.block, className = _this$props2.className, disabled = _this$props2.disabled, invalid = _this$props2.invalid, onMouseDown = _this$props2.onMouseDown, onMouseUp = _this$props2.onMouseUp, autoFocus = _this$props2.autoFocus, holdAffordance = _this$props2.holdAffordance, otherProps = (0, $44efc5708ae02dcc$var$_objectWithoutProperties2["default"])(_this$props2, [
                    "element",
                    "label",
                    "children",
                    "variant",
                    "logic",
                    "quiet",
                    "icon",
                    "selected",
                    "block",
                    "className",
                    "disabled",
                    "invalid",
                    "onMouseDown",
                    "onMouseUp",
                    "autoFocus",
                    "holdAffordance"
                ]); // Map variants for backwards compatibility
                if ($44efc5708ae02dcc$var$VARIANTS[variant]) {
                    var mappedVariant = $44efc5708ae02dcc$var$VARIANTS[variant];
                    var variantName = (mappedVariant.quiet ? "quiet " : "") + '"'.concat(mappedVariant.variant, '"');
                    console.warn('The "'.concat(variant, '" variant of Button is deprecated. Please use the ').concat(variantName, " variant instead."));
                    variant = mappedVariant.variant;
                    quiet = mappedVariant.quiet;
                }
                var shouldRenderHoldAffordance = false; // Some button variants were broken out into their own components, map them appropriately
                var baseButtonClass = "spectrum-Button";
                if (variant === "action" || variant === "toggle") {
                    baseButtonClass = "spectrum-ActionButton";
                    shouldRenderHoldAffordance = holdAffordance;
                    if (variant === "toggle") quiet = true;
                    variant = "";
                } else if (logic) baseButtonClass = "spectrum-LogicButton";
                else if (variant === "clear") {
                    baseButtonClass = "spectrum-ClearButton";
                    variant = "";
                } else if (variant === "field") {
                    baseButtonClass = "spectrum-FieldButton";
                    variant = "";
                } else if (variant === "tool") {
                    baseButtonClass = "spectrum-Tool"; // hold affordance is really only a part of tool.
                    shouldRenderHoldAffordance = holdAffordance;
                    variant = "";
                }
                if (Element !== "button") {
                    otherProps.role = "button";
                    otherProps.tabIndex = disabled ? null : otherProps.tabIndex || 0;
                    otherProps["aria-disabled"] = disabled || null;
                    if (Element === "a" && disabled && otherProps.href) otherProps.href = null;
                    otherProps.onKeyDown = disabled ? null : this.onKeyDownSpace;
                }
                var labelContents = label || (typeof children === "string" ? children : null);
                var ariaExpanded = null;
                if (otherProps["aria-expanded"] !== undefined) ariaExpanded = otherProps["aria-expanded"];
                else if (otherProps["aria-haspopup"]) ariaExpanded = selected || null;
                var filteredProps = typeof Element === "string" ? (0, $44efc5708ae02dcc$var$_filterDOMProps["default"])(otherProps) : otherProps;
                return $44efc5708ae02dcc$var$_react["default"].createElement(Element, (0, $44efc5708ae02dcc$var$_extends2["default"])({}, filteredProps, {
                    className: (0, $44efc5708ae02dcc$var$_classnames["default"])(baseButtonClass, quiet ? "".concat(baseButtonClass, "--quiet") : "", variant ? "".concat(baseButtonClass, "--").concat(variant) : "", (0, $44efc5708ae02dcc$var$_defineProperty2["default"])({
                        "is-selected": selected,
                        "is-disabled": disabled,
                        "is-invalid": invalid,
                        "spectrum-Button--block": block
                    }, $44efc5708ae02dcc$var$_focusRing.FOCUS_RING_CLASSNAME, autoFocus), className),
                    disabled: disabled,
                    "aria-invalid": invalid || null,
                    "aria-expanded": ariaExpanded,
                    onClick: this.onClick,
                    onMouseDown: (0, $8lubB.chain)(this.onMouseDown, $8lubB.focusAfterMouseEvent.bind(this, onMouseDown)),
                    onMouseUp: (0, $8lubB.chain)(this.onMouseUp, $8lubB.focusAfterMouseEvent.bind(this, onMouseUp)),
                    ref: this.setButtonRef
                }), (0, $2xydG.cloneIcon)(icon, {
                    size: "S"
                }), labelContents && $44efc5708ae02dcc$var$_react["default"].createElement("span", {
                    className: baseButtonClass + "-label"
                }, labelContents), shouldRenderHoldAffordance && $44efc5708ae02dcc$var$_react["default"].createElement($44efc5708ae02dcc$var$_CornerTriangle["default"], {
                    role: "presentation",
                    size: null,
                    className: "spectrum-Tool-hold"
                }), typeof children !== "string" && children);
            }
        }
    ]);
    return Button;
}($44efc5708ae02dcc$var$_react.Component), (0, $44efc5708ae02dcc$var$_defineProperty2["default"])($44efc5708ae02dcc$var$_class2, "propTypes", {
    /**
   * The variant of button to display
   */ variant: $44efc5708ae02dcc$var$_propTypes["default"].oneOf([
        "cta",
        "primary",
        "secondary",
        "warning",
        "action",
        "toggle",
        "and",
        "or",
        "icon",
        "quiet",
        "minimal",
        "dropdown",
        "clear",
        "field",
        "tool",
        "overBackground"
    ]),
    /**
   * Whether the button should render using a quiet variant
   */ quiet: $44efc5708ae02dcc$var$_propTypes["default"].bool,
    /**
   * Whether the button is a logic button variant
   */ logic: $44efc5708ae02dcc$var$_propTypes["default"].bool,
    /**
   * Whether the button is disabled
   */ disabled: $44efc5708ae02dcc$var$_propTypes["default"].bool,
    /**
   * Whether the button represents a selected state
   */ selected: $44efc5708ae02dcc$var$_propTypes["default"].bool,
    /**
   * Whether the button represents an invalid state
   */ invalid: $44efc5708ae02dcc$var$_propTypes["default"].bool,
    /**
   * An icon to render in the button.
   */ icon: $44efc5708ae02dcc$var$_propTypes["default"].element,
    /**
   * The label to display in the button
   */ label: $44efc5708ae02dcc$var$_propTypes["default"].string,
    /**
   * Whether the button is a block element
   */ block: $44efc5708ae02dcc$var$_propTypes["default"].bool,
    /**
   * The DOM element to use to render the button
   */ element: $44efc5708ae02dcc$var$_propTypes["default"].oneOfType([
        $44efc5708ae02dcc$var$_propTypes["default"].string,
        $44efc5708ae02dcc$var$_propTypes["default"].func
    ]),
    /**
   * Whether the button should be auto focused on mount
   */ autoFocus: $44efc5708ae02dcc$var$_propTypes["default"].bool,
    /**
   * A click handler for the button
   */ onClick: $44efc5708ae02dcc$var$_propTypes["default"].func,
    /**
   * A visual variation that puts a small triangle in the lower right
   */ holdAffordance: $44efc5708ae02dcc$var$_propTypes["default"].bool
}), (0, $44efc5708ae02dcc$var$_defineProperty2["default"])($44efc5708ae02dcc$var$_class2, "defaultProps", {
    autoFocus: false,
    block: false,
    disabled: false,
    element: "button",
    invalid: false,
    label: "",
    logic: false,
    quiet: false,
    selected: false,
    variant: "secondary",
    holdAffordance: false
}), $44efc5708ae02dcc$var$_temp)) || $44efc5708ae02dcc$var$_class) || $44efc5708ae02dcc$var$_class;
module.exports["default"] = $44efc5708ae02dcc$var$Button;

});
parcelRegister("2xydG", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneIcon = $1d993529217a621b$var$cloneIcon;

var $1d993529217a621b$var$_classnames = $l4FIw((parcelRequire("g3elz")));

var $1d993529217a621b$var$_react = $l4FIw((parcelRequire("7eprg")));
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ function $1d993529217a621b$var$cloneIcon(icon) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!icon) return null;
    if (typeof icon === "string") throw new Error("String icon names are deprecated. Pass icons by importing them from react-spectrum/Icon/IconName and render as <IconName />.");
    var className = opts.className, size = opts.size, ariaLabel = opts["aria-label"], ariaHidden = opts["aria-hidden"], _opts$alt = opts.alt, alt = _opts$alt === void 0 ? ariaLabel || icon.props["aria-label"] || icon.props.alt : _opts$alt;
    return $1d993529217a621b$var$_react["default"].cloneElement(icon, {
        className: (0, $1d993529217a621b$var$_classnames["default"])(className, icon.props.className),
        size: icon.props.size || size,
        "aria-label": ariaLabel || alt,
        alt: alt,
        "aria-hidden": ariaHidden || (alt ? icon.props["aria-hidden"] : true)
    });
}

});

parcelRegister("clRb7", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $8fe0b24cd7d331f4$var$convertUnsafeMethod;

var $8fe0b24cd7d331f4$var$_semverCompare = $l4FIw((parcelRequire("ikr1V")));

var $8fe0b24cd7d331f4$var$_react = $l4FIw((parcelRequire("7eprg")));
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ /**
 * This is a decorator that converts UNSAFE React lifecycle methods to their pre-React 16.3.0 variant
*/ function $8fe0b24cd7d331f4$var$convertUnsafeMethod(WrappedComponent) {
    var proto = WrappedComponent.prototype;
    var UNSAFE_componentWillUpdate = proto.UNSAFE_componentWillUpdate;
    var UNSAFE_componentWillMount = proto.UNSAFE_componentWillMount;
    var UNSAFE_componentWillReceiveProps = proto.UNSAFE_componentWillReceiveProps;
    if ((0, $8fe0b24cd7d331f4$var$_semverCompare["default"])($8fe0b24cd7d331f4$var$_react["default"].version, "16.3.0") === -1) {
        if (UNSAFE_componentWillUpdate) proto.componentWillUpdate = function(props, state) {
            UNSAFE_componentWillUpdate.apply(this, arguments);
        };
        if (UNSAFE_componentWillMount) proto.componentWillMount = function() {
            UNSAFE_componentWillMount.apply(this, arguments);
        };
        if (UNSAFE_componentWillReceiveProps) proto.componentWillReceiveProps = function(props) {
            UNSAFE_componentWillReceiveProps.apply(this, arguments);
        };
    }
}

});
parcelRegister("ikr1V", function(module, exports) {
module.exports = function cmp(a, b) {
    var pa = a.split(".");
    var pb = b.split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    return 0;
};

});


parcelRegister("8XmkT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $32iuA = parcelRequire("32iuA");
var $685528e4bd797a0f$var$_Icon2 = $685528e4bd797a0f$var$_interopRequireDefault($32iuA);

var $7eprg = parcelRequire("7eprg");
var $685528e4bd797a0f$var$_react2 = $685528e4bd797a0f$var$_interopRequireDefault($7eprg);
function $685528e4bd797a0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $685528e4bd797a0f$var$WrappedIcon = function WrappedIcon(props) {
    return $685528e4bd797a0f$var$_react2.default.createElement($685528e4bd797a0f$var$_Icon2.default, props, $685528e4bd797a0f$var$_react2.default.createElement("svg", {
        className: "spectrum-UIIcon-CornerTriangle"
    }, $685528e4bd797a0f$var$_react2.default.createElement("path", {
        d: "M4.74.01a.25.25 0 0 0-.177.073l-4.48 4.48a.25.25 0 0 0 .177.427h4.48a.25.25 0 0 0 .25-.25V.26a.25.25 0 0 0-.25-.25z",
        className: "spectrum-UIIcon--medium"
    }), $685528e4bd797a0f$var$_react2.default.createElement("path", {
        d: "M5.74.01a.25.25 0 0 0-.177.073l-5.48 5.48a.25.25 0 0 0 .177.427h5.48a.25.25 0 0 0 .25-.25V.26a.25.25 0 0 0-.25-.25z",
        className: "spectrum-UIIcon--large"
    })));
};
$685528e4bd797a0f$var$WrappedIcon.displayName = "CornerTriangle";
module.exports.default = $685528e4bd797a0f$var$WrappedIcon;

});
parcelRegister("32iuA", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $235fe7375f8207c7$var$Icon;

var $235fe7375f8207c7$var$_defineProperty2 = $l4FIw((parcelRequire("jIgr0")));

var $235fe7375f8207c7$var$_objectWithoutProperties2 = $l4FIw((parcelRequire("ib1Q9")));

var $235fe7375f8207c7$var$_classnames = $l4FIw((parcelRequire("g3elz")));

var $235fe7375f8207c7$var$_propTypes = $l4FIw((parcelRequire("h4kRK")));

var $235fe7375f8207c7$var$_react = $l4FIw((parcelRequire("7eprg")));
function $235fe7375f8207c7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $235fe7375f8207c7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $235fe7375f8207c7$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $235fe7375f8207c7$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $235fe7375f8207c7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var $235fe7375f8207c7$var$SIZES = {
    XXS: 18,
    XS: 24,
    S: 18,
    M: 24,
    L: 18,
    XL: 24,
    XXL: 24
};
function $235fe7375f8207c7$var$Icon(_ref) {
    var icon = _ref.icon, _ref$size = _ref.size, size = _ref$size === void 0 ? "M" : _ref$size, className = _ref.className, children = _ref.children, ariaLabel = _ref["aria-label"], ariaHidden = _ref["aria-hidden"], _ref$role = _ref.role, role = _ref$role === void 0 ? "img" : _ref$role, alt = _ref.alt, otherProps = (0, $235fe7375f8207c7$var$_objectWithoutProperties2["default"])(_ref, [
        "icon",
        "size",
        "className",
        "children",
        "aria-label",
        "aria-hidden",
        "role",
        "alt"
    ]);
    var sizeKey = $235fe7375f8207c7$var$SIZES[size];
    var svg = icon && icon[sizeKey] || icon || children;
    if (typeof svg === "string") throw new Error("String icon names are deprecated. Please import icons from react-spectrum/Icon/IconName and render as <IconName />.");
    if (!ariaHidden || ariaHidden === "false") ariaHidden = undefined;
    return $235fe7375f8207c7$var$_react["default"].cloneElement(svg, $235fe7375f8207c7$var$_objectSpread({
        focusable: "false",
        "aria-label": ariaLabel || alt,
        "aria-hidden": ariaLabel || alt ? ariaHidden : true,
        role: role,
        className: (0, $235fe7375f8207c7$var$_classnames["default"])(svg.props.className, "spectrum-Icon", (0, $235fe7375f8207c7$var$_defineProperty2["default"])({}, "spectrum-Icon--size".concat(size), size), className)
    }, otherProps));
}
$235fe7375f8207c7$var$Icon.displayName = "Icon";
$235fe7375f8207c7$var$Icon.propTypes = {
    /**
   * Size of icon, XXS to XXL
   */ size: $235fe7375f8207c7$var$_propTypes["default"].string
};

});


parcelRegister("6B4CL", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4cd9c908828e6ca2$var$focusRing;
module.exports.FOCUS_RING_CLASSNAME = void 0;

var $4cd9c908828e6ca2$var$_react = $l4FIw((parcelRequire("7eprg")));

var $4cd9c908828e6ca2$var$_reactDom = $l4FIw((parcelRequire("5hg2n")));
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ var $4cd9c908828e6ca2$var$FOCUS_RING_CLASSNAME = "focus-ring";
/**
 * This is a decorator that ensures a focus-ring className set by the focus-ring-polyfill
 * is retained when a focused component is rendered following a state change.
*/ module.exports.FOCUS_RING_CLASSNAME = $4cd9c908828e6ca2$var$FOCUS_RING_CLASSNAME;
function $4cd9c908828e6ca2$var$focusRing(WrappedComponent) {
    var proto = WrappedComponent.prototype;
    var UNSAFE_componentWillUpdate = proto.UNSAFE_componentWillUpdate;
    var componentDidUpdate = proto.componentDidUpdate;
    var elementWithFocusRing = null;
    proto.UNSAFE_componentWillUpdate = function(props, state) {
        // call original method
        if (UNSAFE_componentWillUpdate) UNSAFE_componentWillUpdate.apply(this, arguments);
        if (elementWithFocusRing == null || elementWithFocusRing !== document.activeElement) try {
            var node = $4cd9c908828e6ca2$var$_reactDom["default"].findDOMNode(this);
            elementWithFocusRing = node.parentNode.querySelector("." + $4cd9c908828e6ca2$var$FOCUS_RING_CLASSNAME);
        } catch (error) {}
    };
    proto.componentDidUpdate = function(props, state) {
        // call original method
        if (componentDidUpdate) componentDidUpdate.apply(this, arguments);
        try {
            var node = $4cd9c908828e6ca2$var$_reactDom["default"].findDOMNode(this);
            if (elementWithFocusRing && (document.activeElement === elementWithFocusRing || node.contains(document.activeElement)) && !elementWithFocusRing.classList.contains($4cd9c908828e6ca2$var$FOCUS_RING_CLASSNAME)) {
                document.activeElement.classList.add($4cd9c908828e6ca2$var$FOCUS_RING_CLASSNAME);
                elementWithFocusRing = null;
            }
        } catch (error) {}
    };
}

});



parcelRegister("h6JMM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $32iuA = parcelRequire("32iuA");
var $c7468354e431c3f3$var$_Icon2 = $c7468354e431c3f3$var$_interopRequireDefault($32iuA);

var $7eprg = parcelRequire("7eprg");
var $c7468354e431c3f3$var$_react2 = $c7468354e431c3f3$var$_interopRequireDefault($7eprg);
function $c7468354e431c3f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c7468354e431c3f3$var$WrappedIcon = function WrappedIcon(props) {
    return $c7468354e431c3f3$var$_react2.default.createElement($c7468354e431c3f3$var$_Icon2.default, props, $c7468354e431c3f3$var$_react2.default.createElement("svg", {
        className: "spectrum-UIIcon-AlertMedium"
    }, $c7468354e431c3f3$var$_react2.default.createElement("path", {
        d: "M8.564 1.289L.2 16.256A.5.5 0 0 0 .636 17h16.728a.5.5 0 0 0 .5-.5.494.494 0 0 0-.064-.244L9.436 1.289a.5.5 0 0 0-.872 0zM10 14.75a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25zm0-3a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-6a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25z",
        className: "spectrum-UIIcon--medium"
    }), $c7468354e431c3f3$var$_react2.default.createElement("path", {
        d: "M10.563 2.206l-9.249 16.55a.5.5 0 0 0 .436.744h18.5a.5.5 0 0 0 .5-.5.494.494 0 0 0-.064-.244l-9.251-16.55a.5.5 0 0 0-.872 0zM12 17.25a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25zm0-3.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-6a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25z",
        className: "spectrum-UIIcon--large"
    })));
};
$c7468354e431c3f3$var$WrappedIcon.displayName = "AlertMedium";
module.exports.default = $c7468354e431c3f3$var$WrappedIcon;

});

parcelRegister("huRgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ var $03498672346d03dc$var$PREFIX = "react-spectrum-";
var $03498672346d03dc$var$incrementor = 0;
var $03498672346d03dc$var$_default = function _default() {
    return $03498672346d03dc$var$PREFIX + ++$03498672346d03dc$var$incrementor;
};
module.exports["default"] = $03498672346d03dc$var$_default;

});


//# sourceMappingURL=js-deferred.b37b29e0.js.map
